import { render, staticRenderFns } from "./SupportAttachmentViewer.vue?vue&type=template&id=0d01a284&"
import script from "./SupportAttachmentViewer.vue?vue&type=script&lang=js&"
export * from "./SupportAttachmentViewer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports